<div class="pt-5 bg-white">
    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-10">
            <div class="d-flex align-items-center">
                <button class="btn btn-sm action-btn mr-3" (click)="cancel()" title="Back">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <div class="header-content">{{ isNew ? 'Add Language Content' : 'Edit Language Content' }}</div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>
</div>

<div class="row ml-0 mt-4" *ngIf="!isLoading">
    <div class="col-1"></div>
    <div class="col-10">

        <!-- Language selector + status -->
        <div class="d-flex align-items-center mb-4" style="gap: 24px;">
            <div class="form-group mb-0" style="min-width: 220px;">
                <label class="font-weight-bold">Language</label>
                <select class="form-control mt-2"
                    [(ngModel)]="selectedLanguageId"
                    [disabled]="!isNew">
                    <option *ngFor="let l of availableLanguages" [value]="l.language_id">
                        {{ l.language_name }} ({{ l.language_code }})
                    </option>
                </select>
            </div>
            <div class="form-group mb-0" style="min-width: 160px;">
                <label class="font-weight-bold">Status</label>
                <select class="form-control mt-2" [(ngModel)]="selectedStatus">
                    <option value="active">active</option>
                    <option value="inactive">inactive</option>
                </select>
            </div>
        </div>

        <!-- Key-value form grouped by section -->
        <div *ngIf="isNew" class="sub-content mb-4">
            Select a language and save — the translation form will appear after the first save.
        </div>

        <mat-accordion class="section-accordion mb-5" *ngIf="sections.length">
            <mat-expansion-panel *ngFor="let section of sections; let i = index" [expanded]="i === 0">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ formatSectionLabel(section) }}
                    </mat-panel-title>
                    <mat-panel-description>
                        <span class="section-count-badge">{{ pairsForSection(section).length }} field{{ pairsForSection(section).length === 1 ? '' : 's' }}</span>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div *ngFor="let pair of pairsForSection(section); trackBy: trackByKey" class="form-group row mb-3">
                    <label class="col-4 col-form-label sub-content" style="font-family: monospace; font-size: 13px; word-break: break-all;">
                        {{ pair.key }}
                    </label>
                    <div class="col-8">
                        <quill-editor
                            *ngIf="isRichTextAnswer(pair); else plainTextField"
                            class="d-block"
                            [(ngModel)]="pair.value"
                            [modules]="quillModules">
                        </quill-editor>
                        <ng-template #plainTextField>
                            <textarea class="form-control" rows="2" [(ngModel)]="pair.value" style="font-size: 13px;"></textarea>
                        </ng-template>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <!-- Actions -->
        <div class="d-flex mb-5" style="gap: 12px;">
            <button class="btn primary-bg text-white" (click)="save()">
                {{ isNew ? 'Create' : 'Save Changes' }}
            </button>
            <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
        </div>
    </div>
    <div class="col-1"></div>
</div>

<div class="row ml-0 mt-5" *ngIf="isLoading">
    <div class="col-12 text-center sub-content">Loading...</div>
</div>
